import Modal from 'react-modal';
import React, {useState, useContext, useRef} from "react";

import { MainContext } from "../../helpers/MainContext";
import LoadingIcon from "../forms/LoadingIcon";
import ExitModalButton from "../forms/ExitModalButton";
import { fetchWithTimeout } from "../../helpers/littleHelpers";


const ObjectsPresentationModal = ( { idOfInterest , name, file } ) => {
    //file has ".url" and ".size" in bytes
    const initialFormValues = {
        objectOfInterestID: idOfInterest,
        email: "",
        mansionName: name,
        presentationLink: file.url,
    };

    const {objectPresentationVisibility, setObjectPresentationVisibility} = useContext(MainContext);
    const [values, setValues] = useState(initialFormValues);
    const [subStatus, setSubStatus] = useState("idle"); // "loading" / "sent" / "error"
    const [errorMessage, setErrorMessage] = useState("");
    const modalHeight = useRef(0);
    const emailMentioned = useRef(values.email);

    const set = name => {
        return ({ target: { value } }) => {
            setValues(oldValues => ({ ...oldValues, [name]: value }))
        }
    }

    const closeModal = () => {
        if (typeof(document.getElementsByClassName("imageGallery")[0]) != 'undefined' && document.getElementsByClassName("imageGallery")[0] != null) {
            document.getElementsByClassName("imageGallery")[0].style.visibility = "visible";
        }
        setObjectPresentationVisibility(false)
        setSubStatus("idle");
    }

    const saveFormData = async () => {
        const response = await fetchWithTimeout('https://hook.integromat.com/k719jrvhgs69ua7hwcei46ap99idnan8', {
            timeout: 5000,
            method: 'POST',
            body: JSON.stringify(values)
        });
        
        if (response.status !== 200) {
            setSubStatus("error");
            throw new Error(`Ошибка соединения: ${response.status}`); 
        } else {
            emailMentioned.current = values.email;
            setSubStatus("sent");
        }
    }
    
    
    const onSubmit = async (e) => {
        e.preventDefault();
        modalHeight.current = document.getElementsByClassName("Modal")[0].offsetHeight;
        setSubStatus("loading");

        try {
            await saveFormData();      
            setValues(initialFormValues);
        } catch (e) {
            setSubStatus("error");
            setErrorMessage(`Отправка не произведена! ${e.message}`);
        }
    }
    
    Modal.setAppElement(`#___gatsby`);

    return (
        <Modal 
        isOpen={objectPresentationVisibility}
        onRequestClose={closeModal}
        className="Modal getPresentation"
        overlayClassName="Overlay"
        >   
            <ExitModalButton closeFunction={closeModal} ariaLabel="Закрыть окно запроса презентации" />
            { subStatus === "idle" &&
                <div className="presentationOptions">
                    <a href={file.url} target="_blank" rel="noreferrer">
                        распечатать сейчас
                        <span>
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="printer-icon" viewBox="0 0 16 16">
                                <path d="M2.5 8a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1z"/>
                                <path d="M5 1a2 2 0 0 0-2 2v2H2a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2h1v1a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-1h1a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-1V3a2 2 0 0 0-2-2H5zM4 3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2H4V3zm1 5a2 2 0 0 0-2 2v1H2a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-1v-1a2 2 0 0 0-2-2H5zm7 2v3a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1z"/>
                            </svg>
                        </span>
                    </a>
                    <p>или</p>
                    <form onSubmit={onSubmit} >
                        <label id="emailLabel" htmlFor="emailForPresentation">
                                отправить на email:
                        </label>
                        <div id="emailWrapper">
                            <input
                                id="emailForPresentation"
                                type="email"
                                name="email"
                                onChange={set("email")}
                                value={values.emailForPresentation}
                                required
                            ></input>
                            <button type="submit" className="sendEmailButton">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="send-icon" viewBox="0 0 16 16">
                                    <path d="M9.502 5.513a.144.144 0 0 0-.202.134V6.65a.5.5 0 0 1-.5.5H2.5v2.9h6.3a.5.5 0 0 1 .5.5v1.003c0 .108.11.176.202.134l3.984-2.933a.51.51 0 0 1 .042-.028.147.147 0 0 0 0-.252.51.51 0 0 1-.042-.028L9.502 5.513zM8.3 5.647a1.144 1.144 0 0 1 1.767-.96l3.994 2.94a1.147 1.147 0 0 1 0 1.946l-3.994 2.94a1.144 1.144 0 0 1-1.767-.96v-.503H2a.5.5 0 0 1-.5-.5v-3.9a.5.5 0 0 1 .5-.5h6.3v-.503z"/>
                                </svg>
                            </button>
                        </div>
                    </form>
                </div>
            }
            { subStatus === "loading" &&
                <div className="loadingContainer" style={{height: `${modalHeight.current}px`}}>
                    <LoadingIcon />
                </div>
            }
            { subStatus === "sent" &&
                <div className="successForm" style={{height: `${modalHeight.current}px`}}>
                    <p>
                        Презентация отправлена по адресу:
                        <br/>
                        <br/>
                        {emailMentioned.current}
                    </p>
                </div>
            }
            { subStatus === "error" &&
                <>  
                    <div className="errorMessage" style={{height: `${modalHeight.current}px`}}>
                        <p>Что-то пошло не так... <br/>Пожалуйста, попробуйте позднее или свяжитесь с нами по телефону +7 (985) 232-87-78</p>
                        <p><code>{errorMessage}</code></p>
                    </div>
                </>
            }
        </Modal>
    )
}

export default ObjectsPresentationModal;